module.exports = __webpack_public_path__ + "static/media/washington-dc.054a0de3.jpg";